import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { provideAnalyticsViewContext } from '@core/analytics-legacy';
import { AnalyticsViewContext } from '@core/analytics-types';
import { DetachedRouterOutlet } from '@core/common-legacy';

import { ProductOrderPersistenceService } from '../../../services/product-order-persistence.service';
import { ProductOrderTrackingService } from '../../../services/product-order-tracking.service';
import { ProductOrderConfigService } from '../config/product-order-config.service';

@Component({
  selector: 'rt-product-order',
  templateUrl: './product-order.component.html',
  styleUrls: ['./product-order.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [provideAnalyticsViewContext(AnalyticsViewContext.Billing)],
  providers: [
    ProductOrderConfigService,
    ProductOrderTrackingService,
    ProductOrderPersistenceService,
  ],
  imports: [DetachedRouterOutlet],
})
export class ProductOrderComponent {
  private readonly config = inject(ProductOrderConfigService);
  private readonly productOrderTrackingService = inject(ProductOrderTrackingService);
  private readonly persistenceService = inject(ProductOrderPersistenceService);

  public ngOnInit() {
    this.persistenceService.clear();
  }

  public ngOnDestroy() {
    this.persistenceService.clear();
  }
}
